import _defineProperty from "/shared/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/shared/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children", "testId"],
    _excluded2 = ["children", "testId"],
    _excluded3 = ["variant", "testId"],
    _excluded4 = ["component", "testId"],
    _excluded5 = ["targetRef", "testId", "children"],
    _excluded6 = ["as", "testId", "value", "formatter", "variant"],
    _excluded7 = ["variant", "testId"],
    _excluded8 = ["testId"],
    _excluded9 = ["testId"],
    _excluded10 = ["children", "testId"],
    _excluded11 = ["testId"],
    _excluded12 = ["testId", "children"],
    _excluded13 = ["testId", "variant", "as"],
    _excluded14 = ["testId"],
    _excluded15 = ["children", "testId"],
    _excluded16 = ["testId", "children"],
    _excluded17 = ["testId", "children"],
    _excluded18 = ["testId", "children"],
    _excluded19 = ["testId", "children"],
    _excluded20 = ["testId", "children"],
    _excluded21 = ["testId", "children"],
    _excluded22 = ["testId", "children"],
    _excluded23 = ["testId", "children"],
    _excluded24 = ["testId", "children"],
    _excluded25 = ["testId", "children"],
    _excluded26 = ["totalQuantity", "activeBullet", "onClick", "testId", "ariaLabelGenerator", "ariaControlsGenerator"],
    _excluded27 = ["testId", "children"],
    _excluded28 = ["onSubmit", "icon", "aria-label", "testId"],
    _excluded29 = ["totalItems", "itemsPerPage", "infiniteMode"],
    _excluded30 = ["icon", "testId"],
    _excluded31 = ["infiniteMode", "controls", "testId", "transition", "children", "id"],
    _excluded32 = ["beforeElementRef", "trapFocusRef", "afterElementRef", "testId", "children"],
    _excluded33 = ["children"],
    _excluded34 = ["isOpen", "children", "onDismiss", "testId"],
    _excluded35 = ["testId", "children", "variant"],
    _excluded36 = ["testId", "children"],
    _excluded37 = ["testId", "children"],
    _excluded38 = ["testId", "children"],
    _excluded39 = ["testId", "title", "aria-label", "children"],
    _excluded40 = ["children", "divider", "testId"],
    _excluded41 = ["children", "loading", "testId"],
    _excluded42 = ["label", "value", "children", "testId"],
    _excluded43 = ["testId", "indices", "onChange", "children"],
    _excluded44 = ["testId", "children", "prefixId", "index"],
    _excluded45 = ["testId", "children"],
    _excluded46 = ["testId", "children"],
    _excluded47 = ["testId", "children"],
    _excluded48 = ["testId", "children"],
    _excluded49 = ["testId", "children", "variant", "scope"],
    _excluded50 = ["children", "testId"],
    _excluded51 = ["children", "testId"],
    _excluded52 = ["children", "testId"],
    _excluded53 = ["testId", "children"],
    _excluded54 = ["quantity", "testId", "leftButtonProps", "inputProps", "rightButtonProps"],
    _excluded55 = ["children", "testId"],
    _excluded56 = ["children", "onClick", "testId"],
    _excluded57 = ["children", "testId", "style"],
    _excluded58 = ["testId", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useState, useRef, useCallback, useEffect, useMemo, useImperativeHandle, useReducer, createContext, useContext, cloneElement } from 'react';
import ReachPopover, { positionDefault } from '@reach/popover';
import { useSwipeable } from 'react-swipeable';
import { createPortal } from 'react-dom';
import { tabbable } from 'tabbable';
var Link = /*#__PURE__*/forwardRef(function Link(_ref2, ref) {
  var {
    as,
    children,
    testId = 'store-link'
  } = _ref2,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  var Component = as != null ? as : 'a';
  return React.createElement(Component, Object.assign({
    ref: ref,
    "data-store-link": true,
    "data-testid": testId
  }, otherProps), children);
});
var Button = /*#__PURE__*/forwardRef(function Button(_ref3, ref) {
  var {
    children,
    testId = 'store-button'
  } = _ref3,
      otherProps = _objectWithoutProperties(_ref3, _excluded2);

  return React.createElement("button", Object.assign({
    ref: ref,
    "data-store-button": true,
    "data-testid": testId
  }, otherProps), children);
});
var Input = /*#__PURE__*/forwardRef(function Input(_ref4, ref) {
  var {
    variant,
    testId = 'store-input'
  } = _ref4,
      otherProps = _objectWithoutProperties(_ref4, _excluded3);

  var variants = {
    'data-error': variant === 'error' || undefined,
    'data-success': variant === 'success' || undefined
  };
  return React.createElement("input", Object.assign({
    ref: ref,
    "data-store-input": true,
    "data-testid": testId
  }, variants, otherProps));
});
var Icon = /*#__PURE__*/forwardRef(function Button(_ref5, ref) {
  var {
    component,
    testId = 'store-icon'
  } = _ref5,
      otherProps = _objectWithoutProperties(_ref5, _excluded4);

  return React.createElement("span", Object.assign({
    ref: ref,
    "data-store-icon": true,
    "data-testid": testId
  }, otherProps), component);
});

var Popover = _ref6 => {
  var {
    targetRef,
    testId = 'store-popover',
    children
  } = _ref6,
      otherProps = _objectWithoutProperties(_ref6, _excluded5);

  return React.createElement(ReachPopover, Object.assign({
    "data-store-popover": true,
    "data-testid": testId,
    position: positionDefault,
    targetRef: targetRef
  }, otherProps), children);
};

var Price = /*#__PURE__*/forwardRef(function Price(_ref7, ref) {
  var {
    as: Component = 'span',
    testId = 'store-price',
    value,
    formatter = price => price,
    variant = 'selling'
  } = _ref7,
      otherProps = _objectWithoutProperties(_ref7, _excluded6);

  var formattedPrice = formatter(value, variant);
  return React.createElement(Component, Object.assign({
    ref: ref,
    "data-store-price": true,
    "data-testid": testId,
    "data-variant": variant
  }, otherProps), formattedPrice);
});
var TextArea = /*#__PURE__*/forwardRef(function TextArea(_ref8, ref) {
  var {
    variant,
    testId = 'store-textarea'
  } = _ref8,
      otherProps = _objectWithoutProperties(_ref8, _excluded7);

  var variants = {
    'data-success': variant === 'success' || undefined,
    'data-error': variant === 'error' || undefined
  };
  return React.createElement("textarea", Object.assign({
    ref: ref,
    "data-store-textarea": true,
    "data-testid": testId
  }, variants, otherProps));
});
var Checkbox = /*#__PURE__*/forwardRef(function Checkbox(_ref9, ref) {
  var {
    testId = 'store-checkbox'
  } = _ref9,
      otherProps = _objectWithoutProperties(_ref9, _excluded8);

  return React.createElement("input", Object.assign({
    ref: ref,
    "data-store-checkbox": true,
    "data-testid": testId,
    type: "checkbox"
  }, otherProps));
});
var Overlay = /*#__PURE__*/forwardRef(function Overlay(_ref10, ref) {
  var {
    testId = 'store-overlay'
  } = _ref10,
      otherProps = _objectWithoutProperties(_ref10, _excluded9);

  return React.createElement("div", Object.assign({
    role: "presentation",
    "data-store-overlay": true,
    "data-testid": testId,
    ref: ref
  }, otherProps));
});
var Select = /*#__PURE__*/forwardRef(function Select(_ref11, ref) {
  var {
    children,
    testId = 'store-select'
  } = _ref11,
      otherProps = _objectWithoutProperties(_ref11, _excluded10);

  return React.createElement("select", Object.assign({
    ref: ref,
    "data-store-select": true,
    "data-testid": testId
  }, otherProps), children);
});
var Radio = /*#__PURE__*/forwardRef(function Radio(_ref12, ref) {
  var {
    testId = 'store-radio'
  } = _ref12,
      otherProps = _objectWithoutProperties(_ref12, _excluded11);

  return React.createElement("input", Object.assign({
    ref: ref,
    "data-store-radio": true,
    "data-testid": testId,
    type: "radio"
  }, otherProps));
});
var Badge = /*#__PURE__*/forwardRef(function Badge(_ref13, ref) {
  var {
    testId = 'store-badge',
    children
  } = _ref13,
      otherProps = _objectWithoutProperties(_ref13, _excluded12);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-store-badge": true,
    "data-testid": testId
  }, otherProps), children);
});
/**
 * This code is inspired by the work of [sandra-lewis](https://codesandbox.io/u/sandra-lewis)
 */

var Slider = _ref14 => {
  var {
    min,
    max,
    onChange,
    testId = 'store-slider',
    getAriaValueText,
    className
  } = _ref14;
  var [minVal, setMinVal] = useState(min);
  var [maxVal, setMaxVal] = useState(max);
  var minValRef = useRef(min);
  var maxValRef = useRef(max);
  var range = useRef(null);
  var getPercent = useCallback(value => Math.round((value - min) / (max - min) * 100), [min, max]); // width of the range to reduce from the left side

  useEffect(() => {
    var minPercent = getPercent(minVal);
    var maxPercent = getPercent(maxValRef.current);

    if (range.current) {
      range.current.style.left = "".concat(minPercent, "%");
      range.current.style.width = "".concat(maxPercent - minPercent, "%");
    }
  }, [minVal, getPercent]); // width of the range to reduce from the right side

  useEffect(() => {
    var minPercent = getPercent(minValRef.current);
    var maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = "".concat(maxPercent - minPercent, "%");
    }
  }, [maxVal, getPercent]);
  useEffect(() => {
    onChange == null ? void 0 : onChange({
      min: minVal,
      max: maxVal
    });
  }, [minVal, maxVal, onChange]);
  return React.createElement("div", {
    "data-store-slider": true,
    "data-testid": testId,
    className: className
  }, React.createElement("div", {
    ref: range,
    "data-slider-range": true
  }), React.createElement("input", {
    type: "range",
    min: min,
    max: max,
    value: minVal,
    onChange: event => {
      var value = Math.min(Number(event.target.value), maxVal - 1);
      setMinVal(value);
      minValRef.current = value;
    },
    "data-slider-thumb": "left",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": minVal,
    "aria-label": String(minVal),
    "aria-labelledby": getAriaValueText ? getAriaValueText(minVal, 'min') : undefined
  }), React.createElement("input", {
    type: "range",
    min: min,
    max: max,
    value: maxVal,
    onChange: event => {
      var value = Math.max(Number(event.target.value), minVal + 1);
      setMaxVal(value);
      maxValRef.current = value;
    },
    "data-slider-thumb": "right",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": maxVal,
    "aria-label": String(maxVal),
    "aria-labelledby": getAriaValueText ? getAriaValueText(maxVal, 'max') : undefined
  }));
};

var variantToElement = {
  description: 'dl',
  unordered: 'ul',
  ordered: 'ol'
};
var List = /*#__PURE__*/forwardRef(function List(_ref15, ref) {
  var {
    testId = 'store-list',
    variant = 'unordered',
    as: MaybeComponent
  } = _ref15,
      otherProps = _objectWithoutProperties(_ref15, _excluded13);

  var _ref;

  var dataAttributes = {
    'data-testid': testId,
    'data-store-list': variant
  };
  var Component = (_ref = MaybeComponent != null ? MaybeComponent : variantToElement[variant]) != null ? _ref : 'ul';
  return React.createElement(Component, Object.assign({
    ref: ref
  }, dataAttributes, otherProps));
});
var Skeleton = /*#__PURE__*/forwardRef(function Skeleton(_ref16, ref) {
  var {
    testId = 'store-skeleton'
  } = _ref16,
      otherProps = _objectWithoutProperties(_ref16, _excluded14);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-store-skeleton": true,
    "data-testid": testId
  }, otherProps));
});
var Spinner = /*#__PURE__*/forwardRef(function Spinner(_ref17, ref) {
  var {
    children,
    testId = 'store-spinner'
  } = _ref17,
      otherProps = _objectWithoutProperties(_ref17, _excluded15);

  return React.createElement("span", Object.assign({
    ref: ref,
    "data-store-spinner": true,
    "data-testid": testId
  }, otherProps));
});
var Label = /*#__PURE__*/forwardRef(function Label(_ref18, ref) {
  var {
    testId = 'store-label',
    children
  } = _ref18,
      otherProps = _objectWithoutProperties(_ref18, _excluded16);

  return React.createElement("label", Object.assign({
    ref: ref,
    "data-store-label": true,
    "data-testid": testId
  }, otherProps), children);
});
var Incentive = /*#__PURE__*/forwardRef(function Incentive(_ref19, ref) {
  var {
    testId = 'store-incentive',
    children
  } = _ref19,
      otherProps = _objectWithoutProperties(_ref19, _excluded17);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-store-incentive": true,
    "data-testid": testId
  }, otherProps), children);
});
var ProductCard = /*#__PURE__*/forwardRef(function Card(_ref20, ref) {
  var {
    testId = 'store-product-card',
    children
  } = _ref20,
      otherProps = _objectWithoutProperties(_ref20, _excluded18);

  return React.createElement("article", Object.assign({
    ref: ref,
    "data-store-product-card": true,
    "data-testid": testId
  }, otherProps), children);
});
var ProductCardImage = /*#__PURE__*/forwardRef(function ProductCardImage(_ref21, ref) {
  var {
    testId = 'store-product-card-image',
    children
  } = _ref21,
      otherProps = _objectWithoutProperties(_ref21, _excluded19);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-product-card-image": true,
    "data-testid": testId
  }, otherProps), children);
});
var ProductCardContent = /*#__PURE__*/forwardRef(function CardContent(_ref22, ref) {
  var {
    testId = 'store-product-card-content',
    children
  } = _ref22,
      otherProps = _objectWithoutProperties(_ref22, _excluded20);

  return React.createElement("section", Object.assign({
    ref: ref,
    "data-product-card-content": true,
    "data-testid": testId
  }, otherProps), children);
});
var ProductCardActions = /*#__PURE__*/forwardRef(function CardActions(_ref23, ref) {
  var {
    testId = 'store-product-card-actions',
    children
  } = _ref23,
      otherProps = _objectWithoutProperties(_ref23, _excluded21);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-product-card-actions": true,
    "data-testid": testId
  }, otherProps), children);
});
var Card = /*#__PURE__*/forwardRef(function Card(_ref24, ref) {
  var {
    testId = 'store-card',
    children
  } = _ref24,
      otherProps = _objectWithoutProperties(_ref24, _excluded22);

  return React.createElement("article", Object.assign({
    ref: ref,
    "data-store-card": true,
    "data-testid": testId
  }, otherProps), children);
});
var CardImage = /*#__PURE__*/forwardRef(function CardImage(_ref25, ref) {
  var {
    testId = 'store-card-image',
    children
  } = _ref25,
      otherProps = _objectWithoutProperties(_ref25, _excluded23);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-card-image": true,
    "data-testid": testId
  }, otherProps), children);
});
var CardContent = /*#__PURE__*/forwardRef(function CardContent(_ref26, ref) {
  var {
    testId = 'store-card-content',
    children
  } = _ref26,
      otherProps = _objectWithoutProperties(_ref26, _excluded24);

  return React.createElement("section", Object.assign({
    ref: ref,
    "data-card-content": true,
    "data-testid": testId
  }, otherProps), children);
});
var CardActions = /*#__PURE__*/forwardRef(function CardActions(_ref27, ref) {
  var {
    testId = 'store-card-actions',
    children
  } = _ref27,
      otherProps = _objectWithoutProperties(_ref27, _excluded25);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-card-actions": true,
    "data-testid": testId
  }, otherProps), children);
});

var defaultAriaLabel = (idx, isActive) => isActive ? 'Current page' : "Go to page ".concat(idx + 1);

var Bullets = /*#__PURE__*/forwardRef(function Bullets(_ref28, ref) {
  var {
    totalQuantity,
    activeBullet,
    onClick: _onClick,
    testId = 'store-bullets',
    ariaLabelGenerator = defaultAriaLabel,
    ariaControlsGenerator
  } = _ref28,
      otherProps = _objectWithoutProperties(_ref28, _excluded26);

  var bulletIndexes = useMemo(() => Array(totalQuantity).fill(0), [totalQuantity]);
  return React.createElement("div", Object.assign({
    ref: ref,
    "data-store-bullets": true,
    "data-testid": testId,
    role: "tablist"
  }, otherProps), bulletIndexes.map((_, idx) => {
    var isActive = activeBullet === idx;
    return React.createElement(Button, {
      "data-bullet-item": true,
      role: "tab",
      tabIndex: -1,
      key: idx,
      testId: "".concat(testId, "-item"),
      onClick: e => _onClick(e, idx),
      "aria-label": ariaLabelGenerator(idx, isActive),
      "aria-controls": ariaControlsGenerator == null ? void 0 : ariaControlsGenerator(idx),
      "aria-selected": isActive
    });
  }));
});
var Form = /*#__PURE__*/forwardRef(function Form(_ref29, ref) {
  var {
    testId = 'store-form',
    children
  } = _ref29,
      otherProps = _objectWithoutProperties(_ref29, _excluded27);

  return React.createElement("form", Object.assign({
    ref: ref,
    "data-store-form": true,
    "data-testid": testId
  }, otherProps), children);
});

var SearchIcon = () => React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("circle", {
  cx: "11",
  cy: "11",
  r: "8"
}), React.createElement("line", {
  x1: "21",
  y1: "21",
  x2: "16.65",
  y2: "16.65"
}));

var SearchInput = /*#__PURE__*/forwardRef(function SearchInput(_ref30, ref) {
  var {
    onSubmit,
    icon,
    'aria-label': ariaLabel = 'search',
    testId = 'store-search-input'
  } = _ref30,
      otherProps = _objectWithoutProperties(_ref30, _excluded28);

  var inputRef = useRef(null);
  var formRef = useRef(null);

  var handleSubmit = event => {
    var _inputRef$current;

    event.preventDefault();

    if (((_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.value) !== '') {
      onSubmit(inputRef.current.value);
    }
  };

  useImperativeHandle(ref, () => ({
    inputRef: inputRef.current,
    formRef: formRef.current
  }));
  return React.createElement(Form, {
    ref: formRef,
    "data-store-search-input": true,
    "data-testid": testId,
    onSubmit: handleSubmit,
    role: "search"
  }, React.createElement(Input, Object.assign({
    ref: inputRef,
    "aria-label": ariaLabel
  }, otherProps)), React.createElement(Button, {
    type: "submit",
    "aria-label": "Submit Search"
  }, React.createElement(Icon, {
    component: icon != null ? icon : React.createElement(SearchIcon, null)
  })));
});

var LeftArrowIcon = _ref31 => {
  var {
    size = {
      width: 25,
      height: 25
    },
    viewBox = '0 0 16 16',
    color = 'currentColor'
  } = _ref31;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: viewBox,
    width: size.width,
    height: size.height
  }, React.createElement("path", {
    d: "M11 1L4 8L11 15",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: color,
    fill: "none"
  }));
};

var RightArrowIcon = _ref32 => {
  var {
    size = {
      width: 25,
      height: 25
    },
    viewBox = '0 0 16 16',
    color = 'currentColor'
  } = _ref32;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: viewBox,
    width: size.width,
    height: size.height
  }, React.createElement("path", {
    d: "M5 15L12 8L5 1",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: color,
    fill: "none"
  }));
};

var nextPage = (current, total) => (current + 1) % total;

var previousPage = (current, total) => (total - (total - current + 1) % total) % total;

function reducer(state, action) {
  switch (action.type) {
    case 'NEXT_PAGE':
      {
        // If `state.infinite` is true, we need to take into account an extra
        // page in the calculation. This extra page is a clone of the first page.
        var adjustedTotalPages = state.infinite ? state.totalPages + 1 : state.totalPages;
        var nextPageIndex = nextPage(state.currentPage, adjustedTotalPages);
        var nextItemIndex = nextPageIndex % adjustedTotalPages * state.itemsPerPage;
        return _objectSpread(_objectSpread({}, state), {}, {
          sliding: true,
          slideDirection: 'next',
          currentItem: nextItemIndex,
          currentPage: nextPageIndex
        });
      }

    case 'PREVIOUS_PAGE':
      {
        // If `state.infinite` is true, we need to take into account an extra
        // page in the calculation. This extra page is a clone of the first page.
        var _adjustedTotalPages = state.infinite ? state.totalPages + 1 : state.totalPages; // If `state.infinite` is true and we're currently on page 0, we need to
        // let the slider go to page -1. This -1 page is a clone of the last page.


        var shouldGoToClone = state.infinite && state.currentPage === 0;
        var previousPageIndex = shouldGoToClone ? -1 : previousPage(state.currentPage, state.totalPages);
        return _objectSpread(_objectSpread({}, state), {}, {
          sliding: true,
          slideDirection: 'previous',
          currentItem: previousPageIndex % _adjustedTotalPages * state.itemsPerPage,
          currentPage: previousPageIndex
        });
      }

    case 'GO_TO_PAGE':
      {
        if (action.payload.pageIndex === state.currentPage) {
          return state;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          sliding: action.payload.shouldSlide,
          slideDirection: action.payload.pageIndex > state.currentPage ? 'next' : 'previous',
          currentItem: action.payload.pageIndex % state.totalPages * state.itemsPerPage,
          currentPage: action.payload.pageIndex
        });
      }

    case 'STOP_SLIDE':
      return _objectSpread(_objectSpread({}, state), {}, {
        sliding: false
      });

    default:
      return state;
  }
}

var defaultSliderState = (totalItems, itemsPerPage, infinite) => ({
  currentItem: 0,
  currentPage: 0,
  sliding: false,
  slideDirection: 'next',
  totalItems,
  itemsPerPage,
  totalPages: Math.ceil(totalItems / itemsPerPage),
  infinite
});

var slide = (page, dispatch) => {
  if (page === 'next') {
    dispatch({
      type: 'NEXT_PAGE'
    });
  }

  if (page === 'previous') {
    dispatch({
      type: 'PREVIOUS_PAGE'
    });
  }

  if (typeof page === 'number') {
    dispatch({
      type: 'GO_TO_PAGE',
      payload: {
        pageIndex: page,
        shouldSlide: true
      }
    });
  }
};

function useSlider(_ref33) {
  var {
    totalItems,
    itemsPerPage = 1,
    infiniteMode = false
  } = _ref33,
      swipeableConfigOverrides = _objectWithoutProperties(_ref33, _excluded29);

  var [sliderState, sliderDispatch] = useReducer(reducer, undefined, () => defaultSliderState(totalItems, itemsPerPage, infiniteMode));
  var handlers = useSwipeable(_objectSpread({
    onSwipedRight: () => slide('previous', sliderDispatch),
    onSwipedLeft: () => slide('next', sliderDispatch),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  }, swipeableConfigOverrides));
  return {
    handlers,
    slide,
    sliderState,
    sliderDispatch
  };
}

function isSlideVisible(_ref34) {
  var {
    itemsPerPage,
    currentSlide,
    slideIdx,
    totalItems
  } = _ref34;
  var isClonedSlide = currentSlide < 0 || currentSlide >= totalItems;
  var isVisible = slideIdx >= currentSlide && slideIdx < currentSlide + itemsPerPage;
  return isClonedSlide || isVisible;
}

function useSlideVisibility(_ref35) {
  var {
    currentSlide,
    itemsPerPage,
    totalItems
  } = _ref35;

  /** Keeps track of slides that have been visualized before.
   * We want to keep rendering them because the issue is mostly rendering
   * slides that might never be viewed; On the other hand, hiding slides
   * that were visible causes visual glitches */
  var visitedSlides = useRef(new Set());
  useEffect(() => {
    for (var i = 0; i < itemsPerPage; i++) {
      visitedSlides.current.add(currentSlide + i);
    }
  }, [currentSlide, itemsPerPage]);

  var isItemVisible = index => isSlideVisible({
    slideIdx: index,
    currentSlide,
    itemsPerPage,
    totalItems
  });

  var shouldRenderItem = index => {
    return visitedSlides.current.has(index) || isItemVisible(index);
  };

  return {
    shouldRenderItem,
    isItemVisible
  };
}

var IconButton = /*#__PURE__*/forwardRef(function IconButton(_ref36, ref) {
  var {
    icon,
    testId = 'store-icon-button'
  } = _ref36,
      buttonProps = _objectWithoutProperties(_ref36, _excluded30);

  return React.createElement(Button, Object.assign({
    ref: ref,
    "data-store-icon-button": true,
    testId: testId
  }, buttonProps), React.createElement(Icon, {
    component: icon
  }));
});

var createTransformValues = (infinite, totalItems) => {
  var transformMap = {};
  var slideWidth = 100 / totalItems;

  for (var idx = 0; idx < totalItems; ++idx) {
    var currIdx = infinite ? idx - 1 : idx;
    var transformValue = -(slideWidth * idx);
    transformMap[currIdx] = transformValue;
  }

  return transformMap;
};

function Carousel(_ref37) {
  var {
    infiniteMode = true,
    controls = 'complete',
    testId = 'store-carousel',
    transition = {
      duration: 400,
      property: 'transform'
    },
    children,
    id = 'store-carousel'
  } = _ref37,
      swipeableConfigOverrides = _objectWithoutProperties(_ref37, _excluded31);

  var _transition$timing, _transition$delay;

  var childrenArray = React.Children.toArray(children);
  var childrenCount = childrenArray.length;
  var numberOfSlides = infiniteMode ? childrenCount + 2 : childrenCount;
  var slidingTransition = "".concat(transition.property, " ").concat(transition.duration, "ms ").concat((_transition$timing = transition.timing) != null ? _transition$timing : '', " ").concat((_transition$delay = transition.delay) != null ? _transition$delay : '');
  var showNavigationArrows = controls === 'complete' || controls === 'navigationArrows';
  var showPaginationBullets = controls === 'complete' || controls === 'paginationBullets';
  var transformValues = useMemo(() => createTransformValues(infiniteMode, numberOfSlides), [numberOfSlides, infiniteMode]);
  var {
    handlers,
    slide,
    sliderState,
    sliderDispatch
  } = useSlider(_objectSpread({
    totalItems: childrenCount,
    itemsPerPage: 1,
    infiniteMode
  }, swipeableConfigOverrides));
  var {
    isItemVisible,
    shouldRenderItem
  } = useSlideVisibility({
    itemsPerPage: sliderState.itemsPerPage,
    currentSlide: sliderState.currentItem,
    totalItems: childrenCount
  });
  var postRenderedSlides = infiniteMode && children ? childrenArray.slice(0, 1) : [];
  var preRenderedSlides = infiniteMode && children ? childrenArray.slice(childrenCount - 1) : [];
  var slides = preRenderedSlides.concat(children != null ? children : [], postRenderedSlides);

  var slidePrevious = () => {
    if (sliderState.sliding || !infiniteMode && sliderState.currentPage === 0) {
      return;
    }

    slide('previous', sliderDispatch);
  };

  var slideNext = () => {
    if (sliderState.sliding || !infiniteMode && sliderState.currentPage === childrenCount - 1) {
      return;
    }

    slide('next', sliderDispatch);
  }; // accessible behavior for tablist


  var handleBulletsKeyDown = event => {
    switch (event.key) {
      case 'ArrowLeft':
        {
          slidePrevious();
          break;
        }

      case 'ArrowRight':
        {
          slideNext();
          break;
        }

      case 'Home':
        {
          slide(0, sliderDispatch);
          break;
        }

      case 'End':
        {
          slide(childrenCount - 1, sliderDispatch);
          break;
        }
    }
  };

  return React.createElement("section", {
    id: id,
    "data-store-carousel": true,
    "data-testid": testId,
    "aria-label": "carousel",
    "aria-roledescription": "carousel"
  }, React.createElement("div", Object.assign({
    "data-carousel-track-container": true,
    style: {
      overflow: 'hidden',
      width: '100%'
    }
  }, handlers), React.createElement("div", {
    "data-carousel-track": true,
    style: {
      display: 'flex',
      transition: sliderState.sliding ? slidingTransition : undefined,
      width: "".concat(numberOfSlides * 100, "%"),
      transform: "translate3d(".concat(transformValues[sliderState.currentPage], "%, 0, 0)")
    },
    onTransitionEnd: () => {
      sliderDispatch({
        type: 'STOP_SLIDE'
      });

      if (sliderState.currentItem >= childrenCount) {
        sliderDispatch({
          type: 'GO_TO_PAGE',
          payload: {
            pageIndex: 0,
            shouldSlide: false
          }
        });
      }

      if (sliderState.currentItem < 0) {
        sliderDispatch({
          type: 'GO_TO_PAGE',
          payload: {
            pageIndex: sliderState.totalPages - 1,
            shouldSlide: false
          }
        });
      }
    },
    "aria-live": "polite"
  }, slides.map((currentSlide, idx) => React.createElement("div", {
    role: "tabpanel",
    "aria-roledescription": "slide",
    key: idx,
    id: "carousel-item-".concat(idx),
    "data-carousel-item": true,
    style: {
      width: '100%'
    },
    "data-visible": isItemVisible(idx - Number(infiniteMode)) || undefined
  }, shouldRenderItem(idx - Number(infiniteMode)) ? currentSlide : null)))), showNavigationArrows && React.createElement("div", {
    "data-carousel-controls": true
  }, React.createElement(IconButton, {
    "aria-label": "previous",
    "data-arrow": "left",
    "aria-controls": id,
    onClick: slidePrevious,
    icon: React.createElement(LeftArrowIcon, null)
  }), React.createElement(IconButton, {
    "aria-label": "next",
    "data-arrow": "right",
    "aria-controls": id,
    onClick: slideNext,
    icon: React.createElement(RightArrowIcon, null)
  })), showPaginationBullets && React.createElement("div", {
    "data-carousel-bullets": true
  }, React.createElement(Bullets, {
    tabIndex: 0,
    totalQuantity: childrenCount,
    activeBullet: sliderState.currentPage,
    onClick: (_, idx) => {
      if (sliderState.sliding) {
        return;
      }

      slide(idx, sliderDispatch);
    },
    ariaControlsGenerator: idx => "carousel-item-".concat(idx),
    onKeyDown: handleBulletsKeyDown,
    onFocus: event => {
      event.currentTarget.focus();
    }
  })));
}
/*
 * Element that will maintain the focus inside trapFocusRef, focus the first element,
 * and focus back on the element that was in focus when useTrapFocus was triggered.
 *
 * Inspired by Reakit useTrapFocus https://github.com/reakit/reakit/blob/a211d94da9f3b683182568a56479b91afb1b85ae/packages/reakit/src/Dialog/__utils/useFocusTrap.ts
 */


var useTrapFocus = _ref38 => {
  var {
    trapFocusRef,
    beforeElementRef,
    afterElementRef
  } = _ref38;
  var tabbableNodesRef = useRef();
  var nodeToRestoreRef = useRef(document.hasFocus() ? document.activeElement : null); // Focus back on the element that was focused when useTrapFocus is triggered.

  useEffect(() => {
    var nodeToRestore = nodeToRestoreRef.current;
    return () => {
      nodeToRestore == null ? void 0 : nodeToRestore.focus();
    };
  }, [nodeToRestoreRef]); // Set focus on first tabbable element

  useEffect(() => {
    if (!trapFocusRef.current) {
      return;
    }

    if (!tabbableNodesRef.current) {
      tabbableNodesRef.current = tabbable(trapFocusRef.current);
    }

    var [firstTabbable] = tabbableNodesRef.current;

    if (!firstTabbable) {
      trapFocusRef.current.focus();
      return;
    }

    firstTabbable.focus();
  }, [trapFocusRef]); // Handle loop focus. Set keydown and focusin event listeners

  useEffect(() => {
    if (!trapFocusRef.current || !beforeElementRef.current || !afterElementRef.current) {
      return;
    }

    var beforeElement = beforeElementRef.current;
    var afterElement = afterElementRef.current;
    var trapFocus = trapFocusRef.current;

    var handleLoopFocus = nativeEvent => {
      if (!document.hasFocus()) {
        return;
      }

      tabbableNodesRef.current = tabbable(trapFocusRef.current);

      if (!tabbableNodesRef.current.length) {
        trapFocus.focus();
      }
      /*
       * Handle loop focus from beforeElementRef. This node can only be focused if the user press shift tab.
       * It will focus the last element of the trapFocusRef.
       */


      if (nativeEvent.target === beforeElement) {
        var _tabbableNodesRef$cur;

        (_tabbableNodesRef$cur = tabbableNodesRef.current[tabbableNodesRef.current.length - 1]) == null ? void 0 : _tabbableNodesRef$cur.focus();
      }
      /*
       * Handle loop focus from afterElementRef. This node can only be focused if the user press tab.
       * It will focus the first element of the trapFocusRef.
       */


      if (nativeEvent.target === afterElement) {
        var _tabbableNodesRef$cur2;

        (_tabbableNodesRef$cur2 = tabbableNodesRef.current[0]) == null ? void 0 : _tabbableNodesRef$cur2.focus();
      }
    };

    beforeElement == null ? void 0 : beforeElement.addEventListener('focusin', handleLoopFocus);
    afterElement == null ? void 0 : afterElement.addEventListener('focusin', handleLoopFocus);
    return () => {
      beforeElement == null ? void 0 : beforeElement.removeEventListener('focusin', handleLoopFocus);
      afterElement == null ? void 0 : afterElement.removeEventListener('focusin', handleLoopFocus);
    };
  }, [tabbableNodesRef, afterElementRef, beforeElementRef, trapFocusRef]);
};

var ModalContentPure = _ref39 => {
  var {
    beforeElementRef,
    trapFocusRef,
    afterElementRef,
    testId = 'store-modal-content',
    children
  } = _ref39,
      otherProps = _objectWithoutProperties(_ref39, _excluded32);

  return React.createElement(React.Fragment, null, React.createElement("div", {
    ref: beforeElementRef,
    "data-testid": "beforeElement",
    tabIndex: 0,
    "aria-hidden": "true"
  }), React.createElement("div", Object.assign({
    "data-store-modal-content": true,
    "data-testid": testId,
    ref: trapFocusRef,
    "aria-modal": "true",
    role: "dialog",
    tabIndex: -1
  }, otherProps), children), React.createElement("div", {
    ref: afterElementRef,
    "data-testid": "afterElement",
    tabIndex: 0,
    "aria-hidden": "true"
  }));
};

var ModalContent = _ref40 => {
  var {
    children
  } = _ref40,
      otherProps = _objectWithoutProperties(_ref40, _excluded33);

  var trapFocusRef = useRef(null);
  var beforeElementRef = useRef(null);
  var afterElementRef = useRef(null);
  useTrapFocus({
    beforeElementRef,
    trapFocusRef,
    afterElementRef
  });
  return React.createElement(ModalContentPure, Object.assign({}, otherProps, {
    trapFocusRef: trapFocusRef,
    beforeElementRef: beforeElementRef,
    afterElementRef: afterElementRef,
    onClick: event => {
      event.stopPropagation();
    }
  }), children);
};
/*
 * This component is based on @reach/dialog.
 * https://github.com/reach/reach-ui/blob/main/packages/dialog/src/index.tsx
 * https://reach.tech/dialog
 */


var Modal = _ref41 => {
  var {
    isOpen,
    children,
    onDismiss,
    testId = 'store-modal'
  } = _ref41,
      otherProps = _objectWithoutProperties(_ref41, _excluded34);

  var handleBackdropClick = event => {
    if (event.defaultPrevented) {
      return;
    }

    event.stopPropagation();
    onDismiss == null ? void 0 : onDismiss(event);
  };

  var handleBackdropKeyDown = event => {
    if (event.key !== 'Escape' || event.defaultPrevented) {
      return;
    }

    event.stopPropagation();
    onDismiss == null ? void 0 : onDismiss(event);
  };

  return isOpen ? createPortal(React.createElement(Overlay, {
    "data-modal-overlay": true,
    onClick: handleBackdropClick,
    onKeyDown: handleBackdropKeyDown
  }, React.createElement(ModalContent, Object.assign({}, otherProps, {
    testId: testId
  }), children)), document.body) : null;
};

var Banner = /*#__PURE__*/forwardRef(function Banner(_ref42, ref) {
  var {
    testId = 'store-banner',
    children,
    variant = 'vertical'
  } = _ref42,
      otherProps = _objectWithoutProperties(_ref42, _excluded35);

  return React.createElement("article", Object.assign({
    ref: ref,
    "data-store-banner": variant,
    "data-testid": testId
  }, otherProps), children);
});
var BannerImage = /*#__PURE__*/forwardRef(function BannerImage(_ref43, ref) {
  var {
    testId = 'store-banner-image',
    children
  } = _ref43,
      otherProps = _objectWithoutProperties(_ref43, _excluded36);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-banner-image": true,
    "data-testid": testId
  }, otherProps), children);
});
var BannerContent = /*#__PURE__*/forwardRef(function BannerContent(_ref44, ref) {
  var {
    testId = 'store-banner-content',
    children
  } = _ref44,
      otherProps = _objectWithoutProperties(_ref44, _excluded37);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-banner-content": true,
    "data-testid": testId
  }, otherProps), children);
});
var BannerLink = /*#__PURE__*/forwardRef(function BannerLink(_ref45, ref) {
  var {
    testId = 'store-banner-link',
    children
  } = _ref45,
      otherProps = _objectWithoutProperties(_ref45, _excluded38);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-banner-link": true,
    "data-testid": testId
  }, otherProps), children);
});
var PaymentMethods = /*#__PURE__*/forwardRef(function PaymentMethods(_ref46, ref) {
  var {
    testId = 'store-payment-methods',
    title,
    'aria-label': ariaLabel = 'Payment Methods',
    children
  } = _ref46,
      otherProps = _objectWithoutProperties(_ref46, _excluded39);

  return React.createElement("div", Object.assign({
    ref: ref,
    "data-store-payment-methods": true,
    "data-testid": testId
  }, otherProps), !!title && React.createElement("div", null, title), React.createElement("div", {
    "data-payment-methods-flags": true,
    "aria-label": title ? undefined : ariaLabel
  }, children));
});

var Divider = _ref47 => {
  var {
    divider,
    testId
  } = _ref47;
  var props = {
    'data-breadcrumb-divider': true,
    'aria-hidden': true,
    'data-testid': "".concat(testId, "-divider")
  };

  if (React.isValidElement(divider)) {
    return React.cloneElement(divider, props);
  }

  return React.createElement("span", Object.assign({}, props), divider != null ? divider : '/');
};

var ListItem = _ref48 => {
  var {
    children,
    isLastItem,
    divider,
    testId
  } = _ref48;
  var props = {
    'data-testid': "".concat(testId, "-item"),
    'data-breadcrumb-item': isLastItem ? 'current' : true,
    'aria-current': isLastItem ? 'page' : undefined
  };

  if (!React.isValidElement(children)) {
    return React.createElement("li", {
      "data-breadcrumb-list-item": true
    }, React.createElement("span", Object.assign({}, props), children, isLastItem ? null : React.createElement(Divider, {
      divider: divider,
      testId: testId
    })));
  }

  return React.createElement("li", {
    "data-breadcrumb-list-item": true
  }, React.cloneElement(children, props), isLastItem ? null : React.createElement(Divider, {
    divider: divider,
    testId: testId
  }));
};

var Breadcrumb = /*#__PURE__*/forwardRef(function Breadcrumb(_ref49, ref) {
  var {
    children,
    divider: rawDivider,
    testId = 'store-breadcrumb'
  } = _ref49,
      otherProps = _objectWithoutProperties(_ref49, _excluded40);

  return React.createElement("nav", Object.assign({
    "aria-label": "Breadcrumb",
    role: "navigation",
    ref: ref,
    "data-store-breadcrumb": true,
    "data-testid": testId
  }, otherProps), React.createElement(List, {
    "data-breadcrumb-list": true,
    variant: "ordered"
  }, React.Children.toArray(children).map((child, index, childrenArray) => {
    var isLastItem = index === childrenArray.length - 1;
    return React.createElement(ListItem, {
      isLastItem: isLastItem,
      divider: rawDivider,
      key: "breadcrumb-".concat(index),
      testId: testId
    }, child);
  })));
});
var LoadingButton = /*#__PURE__*/forwardRef(function LoadingButton(_ref50, ref) {
  var {
    children,
    loading,
    testId = 'store-loading-button'
  } = _ref50,
      otherProps = _objectWithoutProperties(_ref50, _excluded41);

  return React.createElement(Button, Object.assign({
    ref: ref,
    "data-store-loading-button": true,
    testId: testId
  }, otherProps), loading ? React.createElement(Spinner, null) : children);
});

var PriceRange = _ref51 => {
  var {
    className,
    formatter,
    max,
    min,
    onChange,
    testId = 'store-price-range',
    variant,
    'aria-label': ariaLabel
  } = _ref51;
  var [minVal, setMinVal] = useState(min);
  var [maxVal, setMaxVal] = useState(max);

  var handleChange = values => {
    if (values.min !== minVal) {
      setMinVal(values.min);
    }

    if (values.max !== maxVal) {
      setMaxVal(values.max);
    }

    onChange == null ? void 0 : onChange(values);
  };

  return React.createElement("div", {
    "data-store-price-range": true,
    "data-testid": testId,
    className: className
  }, React.createElement(Slider, {
    min: min,
    max: max,
    onChange: handleChange,
    "aria-label": ariaLabel
  }), React.createElement("div", {
    "data-price-range-values": true
  }, React.createElement(Price, {
    formatter: formatter,
    "data-price-range-value": "min",
    value: minVal,
    variant: variant
  }), React.createElement(Price, {
    formatter: formatter,
    "data-price-range-value": "max",
    value: maxVal,
    variant: variant
  })));
};

var RadioGroupContext = /*#__PURE__*/createContext(undefined);

function useRadioGroup() {
  var context = useContext(RadioGroupContext);

  if (!context) {
    throw new Error("useRadioOption hook cannot be used outside the RadioGroup context");
  }

  return context;
}

var RadioGroup = _ref52 => {
  var {
    name,
    onChange,
    children,
    selectedValue
  } = _ref52;
  var contextValues = React.useMemo(() => {
    return {
      name,
      selectedValue,
      onChange
    };
  }, [name, selectedValue, onChange]);
  return React.createElement(RadioGroupContext.Provider, {
    value: contextValues
  }, children);
};

var RadioOption = /*#__PURE__*/forwardRef(function RadioOption(_ref53, ref) {
  var {
    label,
    value,
    children,
    testId = 'store-radio-option'
  } = _ref53,
      otherProps = _objectWithoutProperties(_ref53, _excluded42);

  var {
    name,
    selectedValue,
    onChange
  } = useRadioGroup();
  return React.createElement("label", {
    "aria-label": label,
    "data-store-radio-option": true
  }, React.createElement(Radio, Object.assign({
    "data-store-radio-option-item": true,
    ref: ref,
    name: name,
    checked: value === selectedValue,
    onChange: onChange,
    value: value,
    testId: testId
  }, otherProps)), children);
});
var AccordionContext = /*#__PURE__*/createContext(undefined);
var Accordion = /*#__PURE__*/forwardRef(function Accordion(_ref54, ref) {
  var {
    testId = 'store-accordion',
    indices,
    onChange,
    children
  } = _ref54,
      otherProps = _objectWithoutProperties(_ref54, _excluded43);

  var childrenWithIndex = React.Children.map(children, (child, index) => {
    var _child$props$index;

    return cloneElement(child, {
      index: (_child$props$index = child.props.index) != null ? _child$props$index : index
    });
  });
  var context = {
    indices: new Set(indices),
    onChange,
    numberOfItems: childrenWithIndex.length
  };
  return React.createElement(AccordionContext.Provider, {
    value: context
  }, React.createElement("div", Object.assign({
    ref: ref,
    "data-store-accordion": true,
    "data-testid": testId,
    role: "region"
  }, otherProps), childrenWithIndex));
});

function useAccordion() {
  var context = useContext(AccordionContext);

  if (context === undefined) {
    throw new Error('Do not use Accordion components outside the Accordion context.');
  }

  return context;
}

var AccordionItemContext = /*#__PURE__*/createContext(undefined);
var AccordionItem = /*#__PURE__*/forwardRef(function AccordionItem(_ref55, ref) {
  var {
    testId = 'store-accordion-item',
    children,
    prefixId = '',
    index = 0
  } = _ref55,
      otherProps = _objectWithoutProperties(_ref55, _excluded44);

  var context = {
    index,
    prefixId,
    panel: "".concat(prefixId && "".concat(prefixId, "-"), "panel--").concat(index),
    button: "".concat(prefixId && "".concat(prefixId, "-"), "button--").concat(index)
  };
  return React.createElement(AccordionItemContext.Provider, {
    value: context
  }, React.createElement("div", Object.assign({
    ref: ref,
    "data-accordion-item": true,
    "data-testid": testId
  }, otherProps), children));
});

function useAccordionItem() {
  var context = useContext(AccordionItemContext);

  if (context === undefined) {
    throw new Error('Do not use AccordionItem components outside the AccordionItem context.');
  }

  return context;
}

var AccordionButton = /*#__PURE__*/forwardRef(function AccordionButton(_ref56, ref) {
  var {
    testId = 'store-accordion-button',
    children
  } = _ref56,
      otherProps = _objectWithoutProperties(_ref56, _excluded45);

  var {
    indices,
    onChange,
    numberOfItems
  } = useAccordion();
  var {
    index,
    panel,
    button,
    prefixId
  } = useAccordionItem();

  var onKeyDown = event => {
    var _getNext, _getPrevious;

    if (!['ArrowDown', 'ArrowUp'].includes(event.key)) {
      return;
    }

    var getNext = () => {
      var next = Number(index) + 1 === numberOfItems ? 0 : Number(index) + 1;
      return document.getElementById("".concat(prefixId && "".concat(prefixId, "-"), "button--").concat(next));
    };

    var getPrevious = () => {
      var previous = Number(index) - 1 < 0 ? numberOfItems - 1 : Number(index) - 1;
      return document.getElementById("".concat(prefixId && "".concat(prefixId, "-"), "button--").concat(previous));
    };

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        (_getNext = getNext()) == null ? void 0 : _getNext.focus();
        break;

      case 'ArrowUp':
        event.preventDefault();
        (_getPrevious = getPrevious()) == null ? void 0 : _getPrevious.focus();
        break;
    }
  };

  return React.createElement(Button, Object.assign({
    ref: ref,
    id: button,
    "aria-expanded": indices.has(index),
    "aria-controls": panel,
    "data-accordion-button": true,
    "data-testid": testId,
    onKeyDown: onKeyDown,
    onClick: () => {
      onChange(index);
    }
  }, otherProps), children);
});
var AccordionPanel = /*#__PURE__*/forwardRef(function AccordionPanel(_ref57, ref) {
  var {
    testId = 'store-accordion-panel',
    children
  } = _ref57,
      otherProps = _objectWithoutProperties(_ref57, _excluded46);

  var {
    indices
  } = useAccordion();
  var {
    index,
    button,
    panel
  } = useAccordionItem();
  return React.createElement("div", Object.assign({
    ref: ref,
    id: panel,
    "aria-labelledby": button,
    role: "region",
    "data-accordion-panel": true,
    "data-testid": testId,
    hidden: !indices.has(index)
  }, otherProps), children);
});
var Table = /*#__PURE__*/forwardRef(function Table(_ref58, ref) {
  var {
    testId = 'store-table',
    children
  } = _ref58,
      otherProps = _objectWithoutProperties(_ref58, _excluded47);

  return React.createElement("table", Object.assign({
    ref: ref,
    "data-store-table": true,
    "data-testid": testId
  }, otherProps), children);
});
var TableRow = /*#__PURE__*/forwardRef(function TableRow(_ref59, ref) {
  var {
    testId = 'store-table-row',
    children
  } = _ref59,
      otherProps = _objectWithoutProperties(_ref59, _excluded48);

  return React.createElement("tr", Object.assign({
    ref: ref,
    "data-table-row": true,
    "data-testid": testId
  }, otherProps), children);
});
var TableCell = /*#__PURE__*/forwardRef(function TableCell(_ref60, ref) {
  var {
    testId = 'store-table-cell',
    children,
    variant = 'data',
    scope
  } = _ref60,
      otherProps = _objectWithoutProperties(_ref60, _excluded49);

  var Cell = variant === 'header' ? 'th' : 'td';
  return React.createElement(Cell, Object.assign({
    ref: ref,
    "data-table-cell": variant,
    "data-testid": testId,
    scope: scope
  }, otherProps), children);
});
var TableBody = /*#__PURE__*/forwardRef(function TableBody(_ref61, ref) {
  var {
    children,
    testId = 'store-table-body'
  } = _ref61,
      otherProps = _objectWithoutProperties(_ref61, _excluded50);

  return React.createElement("tbody", Object.assign({
    ref: ref,
    "data-testid": testId,
    "data-table-body": true
  }, otherProps), children);
});
var TableHead = /*#__PURE__*/forwardRef(function TableHead(_ref62, ref) {
  var {
    children,
    testId = 'store-table-head'
  } = _ref62,
      otherProps = _objectWithoutProperties(_ref62, _excluded51);

  return React.createElement("thead", Object.assign({
    ref: ref,
    "data-testid": testId,
    "data-table-head": true
  }, otherProps), children);
});
var TableFooter = /*#__PURE__*/forwardRef(function TableFooter(_ref63, ref) {
  var {
    children,
    testId = 'store-table-footer'
  } = _ref63,
      otherProps = _objectWithoutProperties(_ref63, _excluded52);

  return React.createElement("tfoot", Object.assign({
    ref: ref,
    "data-testid": testId,
    "data-table-footer": true
  }, otherProps), children);
});
var Alert = /*#__PURE__*/forwardRef(function Alert(_ref64, ref) {
  var {
    testId = 'store-alert',
    children
  } = _ref64,
      otherProps = _objectWithoutProperties(_ref64, _excluded53);

  return React.createElement("div", Object.assign({
    ref: ref,
    role: "alert",
    "data-store-alert": true,
    "data-testid": testId
  }, otherProps), children);
});
var QuantitySelector = /*#__PURE__*/forwardRef(function QuantitySelector(_ref65, ref) {
  var {
    quantity,
    testId = 'store-quantity-selector',
    leftButtonProps,
    inputProps,
    rightButtonProps
  } = _ref65,
      otherProps = _objectWithoutProperties(_ref65, _excluded54);

  return React.createElement("div", Object.assign({
    "data-store-quantity-selector": true,
    "data-testid": testId,
    ref: ref
  }, otherProps), React.createElement(IconButton, Object.assign({
    "aria-controls": "quantity-selector-input",
    "aria-label": "Decrement Quantity",
    "data-quantity-selector-button": "left"
  }, leftButtonProps)), React.createElement(Input, Object.assign({
    "aria-label": "Quantity",
    "data-quantity-selector-input": true,
    id: "quantity-selector-input",
    value: quantity
  }, inputProps)), React.createElement(IconButton, Object.assign({
    "aria-controls": "quantity-selector-input",
    "aria-label": "Increment Quantity",
    "data-quantity-selector-button": "right"
  }, rightButtonProps)));
});
var defaultState = {
  isOpen: false,
  dropdownButtonRef: null,
  selectedDropdownItemIndexRef: null,
  dropdownItemsRef: null,
  id: 'store-dropdown'
};
var DropdownContext = /*#__PURE__*/createContext(defaultState);

var Dropdown = _ref66 => {
  var {
    children,
    isOpen: isOpenDefault = false,
    onDismiss,
    id = 'store-dropdown'
  } = _ref66;
  var [isOpen, setIsOpen] = useState(isOpenDefault);
  var dropdownItemsRef = useRef([]);
  var selectedDropdownItemIndexRef = useRef(0);
  var dropdownButtonRef = useRef(null);
  var close = useCallback(() => {
    var _dropdownButtonRef$cu;

    setIsOpen(false);
    onDismiss == null ? void 0 : onDismiss();
    (_dropdownButtonRef$cu = dropdownButtonRef.current) == null ? void 0 : _dropdownButtonRef$cu.focus();
  }, [onDismiss]);

  var open = () => {
    setIsOpen(true);
  };

  var toggle = useCallback(() => {
    setIsOpen(old => {
      if (old) {
        var _dropdownButtonRef$cu2;

        onDismiss == null ? void 0 : onDismiss();
        (_dropdownButtonRef$cu2 = dropdownButtonRef.current) == null ? void 0 : _dropdownButtonRef$cu2.focus();
      }

      return !old;
    });
  }, [onDismiss]);
  useEffect(() => {
    setIsOpen(isOpenDefault);
  }, [isOpenDefault]);
  useEffect(() => {
    var _dropdownItemsRef$cur;

    isOpen && (dropdownItemsRef == null ? void 0 : (_dropdownItemsRef$cur = dropdownItemsRef.current[0]) == null ? void 0 : _dropdownItemsRef$cur.focus());
  }, [isOpen]);
  useEffect(() => {
    var firstClick = true;

    var event = e => {
      var someItemWasClicked = dropdownItemsRef == null ? void 0 : dropdownItemsRef.current.some(item => e.target === item);

      if (firstClick) {
        firstClick = false;
        return;
      }

      !someItemWasClicked && close();
    };

    if (isOpen) {
      document.addEventListener('click', event);
    } else {
      document.removeEventListener('click', event);
    }

    return () => {
      document.removeEventListener('click', event);
    };
  }, [close, isOpen]);
  var value = useMemo(() => {
    return {
      isOpen,
      close,
      open,
      toggle,
      dropdownButtonRef,
      onDismiss,
      selectedDropdownItemIndexRef,
      dropdownItemsRef,
      id
    };
  }, [close, id, isOpen, onDismiss, toggle]);
  return React.createElement(DropdownContext.Provider, {
    value: value
  }, children);
};
/**
 * Hook to use the Dropdown context.
 * @returns Dropdown context.
 */


var useDropdown = () => {
  var context = useContext(DropdownContext);

  if (context === undefined) {
    throw new Error('Do not use useDropdown hook outside the Dropdown context.');
  }

  return context;
};

var DropdownButton = /*#__PURE__*/forwardRef(function Button(_ref67, ref) {
  var {
    children,
    testId = 'store-dropdown-button'
  } = _ref67,
      otherProps = _objectWithoutProperties(_ref67, _excluded55);

  var {
    toggle,
    dropdownButtonRef,
    isOpen,
    id
  } = useDropdown();
  useImperativeHandle(ref, () => dropdownButtonRef.current, [dropdownButtonRef]);
  return React.createElement("button", Object.assign({
    "data-store-dropdown-button": true,
    onClick: toggle,
    "data-testid": testId,
    ref: dropdownButtonRef,
    "aria-expanded": isOpen,
    "aria-haspopup": "menu",
    "aria-controls": id
  }, otherProps), children);
});
var DropdownItem = /*#__PURE__*/forwardRef(function Button(_ref68, ref) {
  var {
    children,
    onClick,
    testId = 'store-dropdown-item'
  } = _ref68,
      otherProps = _objectWithoutProperties(_ref68, _excluded56);

  var {
    dropdownItemsRef,
    selectedDropdownItemIndexRef,
    close
  } = useDropdown();
  var [dropdownItemIndex, setDropdownItemIndex] = useState(0);
  var dropdownItemRef = useRef();

  var addToRefs = el => {
    if (el && !(dropdownItemsRef != null && dropdownItemsRef.current.includes(el))) {
      var _dropdownItemsRef$cur;

      dropdownItemsRef == null ? void 0 : dropdownItemsRef.current.push(el);
      setDropdownItemIndex((_dropdownItemsRef$cur = dropdownItemsRef == null ? void 0 : dropdownItemsRef.current.findIndex(element => element === el)) != null ? _dropdownItemsRef$cur : 0);
    }

    dropdownItemRef.current = el;
  };

  var onFocusItem = () => {
    var _dropdownItemsRef$cur2;

    selectedDropdownItemIndexRef.current = dropdownItemIndex;
    dropdownItemsRef == null ? void 0 : (_dropdownItemsRef$cur2 = dropdownItemsRef.current[selectedDropdownItemIndexRef.current]) == null ? void 0 : _dropdownItemsRef$cur2.focus();
  };

  var handleOnClickItem = event => {
    onClick == null ? void 0 : onClick(event);
    close == null ? void 0 : close();
  };

  useImperativeHandle(ref, () => dropdownItemRef.current, []);
  return React.createElement("button", Object.assign({
    "data-store-dropdown-item": true,
    "data-testid": testId,
    ref: addToRefs,
    onFocus: onFocusItem,
    onMouseEnter: onFocusItem,
    onClick: handleOnClickItem,
    role: "menuitem",
    tabIndex: -1,
    "data-index": dropdownItemIndex
  }, otherProps), children);
});
/**
 * Hook used to find the DropdownMenu position in relation to DropdownButton
 * @returns Style with positions.
 */

var useDropdownPosition = () => {
  var _dropdownButtonRef$cu, _buttonRect$top, _buttonRect$height, _buttonRect$left, _document, _document$documentEle, _document2, _document2$documentEl;

  var {
    dropdownButtonRef
  } = useDropdown(); // Necessary to use this component in SSR

  var isBrowser = typeof window !== 'undefined';
  var buttonRect = dropdownButtonRef == null ? void 0 : (_dropdownButtonRef$cu = dropdownButtonRef.current) == null ? void 0 : _dropdownButtonRef$cu.getBoundingClientRect();
  var topLevel = (_buttonRect$top = buttonRect == null ? void 0 : buttonRect.top) != null ? _buttonRect$top : 0;
  var topOffset = (_buttonRect$height = buttonRect == null ? void 0 : buttonRect.height) != null ? _buttonRect$height : 0;
  var leftLevel = (_buttonRect$left = buttonRect == null ? void 0 : buttonRect.left) != null ? _buttonRect$left : 0; // The scroll properties fix the position of DropdownMenu when the scroll is activated.

  var scrollTop = isBrowser ? (_document = document) == null ? void 0 : (_document$documentEle = _document.documentElement) == null ? void 0 : _document$documentEle.scrollTop : 0;
  var scrollLeft = isBrowser ? (_document2 = document) == null ? void 0 : (_document2$documentEl = _document2.documentElement) == null ? void 0 : _document2$documentEl.scrollLeft : 0;
  var topPosition = topLevel + topOffset + scrollTop;
  var leftPosition = leftLevel + scrollLeft;
  return {
    position: 'absolute',
    top: topPosition,
    left: leftPosition
  };
};
/*
 * This component is based on @reach/dialog.
 * https://github.com/reach/reach-ui/blob/main/packages/dialog/src/index.tsx
 * https://reach.tech/dialog
 */


var DropdownMenu = _ref69 => {
  var {
    children,
    testId = 'store-dropdown-menu',
    style
  } = _ref69,
      otherProps = _objectWithoutProperties(_ref69, _excluded57);

  var {
    isOpen,
    close,
    dropdownItemsRef,
    selectedDropdownItemIndexRef,
    id
  } = useDropdown();
  var dropdownPosition = useDropdownPosition();
  var childrenLength = React.Children.toArray(children).length;

  var handleDownPress = () => {
    var _dropdownItemsRef$cur;

    if (selectedDropdownItemIndexRef.current < childrenLength - 1) {
      selectedDropdownItemIndexRef.current++;
    } else {
      selectedDropdownItemIndexRef.current = 0;
    }

    dropdownItemsRef == null ? void 0 : (_dropdownItemsRef$cur = dropdownItemsRef.current[selectedDropdownItemIndexRef.current]) == null ? void 0 : _dropdownItemsRef$cur.focus();
  };

  var handleUpPress = () => {
    var _dropdownItemsRef$cur2;

    if (selectedDropdownItemIndexRef.current > 0) {
      selectedDropdownItemIndexRef.current--;
    } else {
      selectedDropdownItemIndexRef.current = childrenLength - 1;
    }

    dropdownItemsRef == null ? void 0 : (_dropdownItemsRef$cur2 = dropdownItemsRef.current[selectedDropdownItemIndexRef.current]) == null ? void 0 : _dropdownItemsRef$cur2.focus();
  };

  var handleHomePress = () => {
    var _dropdownItemsRef$cur3;

    selectedDropdownItemIndexRef.current = 0;
    dropdownItemsRef == null ? void 0 : (_dropdownItemsRef$cur3 = dropdownItemsRef.current[selectedDropdownItemIndexRef.current]) == null ? void 0 : _dropdownItemsRef$cur3.focus();
  };

  var handleEndPress = () => {
    var _dropdownItemsRef$cur4;

    selectedDropdownItemIndexRef.current = childrenLength - 1;
    dropdownItemsRef == null ? void 0 : (_dropdownItemsRef$cur4 = dropdownItemsRef.current[selectedDropdownItemIndexRef.current]) == null ? void 0 : _dropdownItemsRef$cur4.focus();
  };

  var handleEscapePress = () => {
    close == null ? void 0 : close();
  };

  var handleBackdropKeyDown = event => {
    if (event.defaultPrevented || event.key === 'Enter') {
      return;
    }

    event.preventDefault();
    event.key === 'Escape' && handleEscapePress();
    event.key === 'ArrowDown' && handleDownPress();
    event.key === 'ArrowUp' && handleUpPress();
    event.key === 'Home' && handleHomePress();
    event.key === 'End' && handleEndPress();
    event.stopPropagation();
  };

  var clearChildrenReferences = () => {
    dropdownItemsRef.current = [];
    return null;
  };

  return isOpen ? createPortal(React.createElement("div", {
    role: "presentation",
    "data-store-dropdown-overlay": true,
    onKeyDown: handleBackdropKeyDown,
    "data-testid": "".concat(testId, "-overlay")
  }, React.createElement("div", Object.assign({
    role: "menu",
    "aria-orientation": "vertical",
    "data-store-dropdown-menu": true,
    "data-testid": testId,
    style: _objectSpread(_objectSpread({}, dropdownPosition), style),
    id: id
  }, otherProps), children)), document.body) : clearChildrenReferences();
};

var OutOfStock = _ref70 => {
  var {
    testId = 'store-out-of-stock',
    children
  } = _ref70,
      otherProps = _objectWithoutProperties(_ref70, _excluded58);

  return React.createElement("section", {
    "data-store-out-of-stock": true,
    "data-testid": testId
  }, React.createElement(Form, Object.assign({
    "data-out-of-stock-form": true,
    testId: "".concat(testId, "-form")
  }, otherProps), children));
};

var OutOfStockMessage = _ref71 => {
  var {
    as: MessageComponent = 'p',
    testId = 'store-out-of-stock-message',
    children
  } = _ref71;
  return React.createElement(MessageComponent, {
    "data-out-of-stock-message": true,
    "data-testid": testId
  }, children);
};

var OutOfStockTitle = _ref72 => {
  var {
    as: TitleComponent = 'h2',
    testId = 'store-out-of-stock-title',
    children
  } = _ref72;
  return React.createElement(TitleComponent, {
    "data-out-of-stock-title": true,
    "data-testid": testId
  }, children);
};

export { Accordion, AccordionButton, AccordionItem, AccordionPanel, Alert, Badge, Banner, BannerContent, BannerImage, BannerLink, Breadcrumb, Bullets, Button, Card, CardActions, CardContent, CardImage, Carousel, Checkbox, Dropdown, DropdownButton, DropdownItem, DropdownMenu, Form, Icon, IconButton, Incentive, Input, Label, Link, List, LoadingButton, Modal, OutOfStock, OutOfStockMessage, OutOfStockTitle, Overlay, PaymentMethods, Popover, Price, PriceRange, ProductCard, ProductCardActions, ProductCardContent, ProductCardImage, QuantitySelector, Radio, RadioGroup, RadioOption, SearchInput, Select, Skeleton, Slider, Spinner, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, TextArea, useSlider };